import firebase from 'firebase'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'signin',
      path: '/signin',
      component: () => import('@/views/auth/SignIn.vue'),
    },
    {
      name: 'signup',
      path: '/signup',
      component: () => import('@/views/auth/SignUp.vue'),
    },
    {
      name: 'password',
      path: '/password',
      component: () => import('@/views/auth/Password.vue'),
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          redirect: 'dashboard', // default child path
        },
        {
          name: 'dashboard',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard.vue'),
        },
        {
          name: 'evaluations',
          path: 'evaluations',
          component: () => import('@/views/evaluations/Evaluations.vue'),
        },
        {
          name: 'evaluations.create',
          path: 'evaluations/create',
          component: () => import('@/views/evaluations/CreateEditEvaluation.vue'),
        },
        {
          name: 'evaluations.edit',
          path: 'evaluations/:id/edit',
          component: () => import('@/views/evaluations/CreateEditEvaluation.vue'),
        },

        {
          name: 'ingredients',
          path: 'ingredients',
          component: () => import('@/views/ingredients/Ingredients.vue'),
        },
        {
          name: 'ingredients.view',
          path: 'ingredients/:id',
          component: () => import('@/views/ingredients/ViewIngredient.vue'),
        },
        {
          name: 'ingredients.edit',
          path: 'ingredients/:id/edit',
          component: () => import('@/views/ingredients/ViewIngredient.vue'),
        },
        {
          name: 'products',
          path: 'products',
          component: () => import('@/views/products/Products.vue'),
        },
        {
          name: 'products.create',
          path: 'products/create',
          component: () => import('@/views/products/CreateEditProduct.vue'),
        },
        {
          name: 'products.edit',
          path: 'products/:id/edit',
          component: () => import('@/views/products/CreateEditProduct.vue'),
        },
        {
          name: 'templates',
          path: 'templates',
          component: () => import('@/views/templates/Templates.vue'),
        },
        {
          name: 'templates.instructions',
          path: 'templates/instructions',
          component: () => import('@/views/templates/Instructions.vue'),
        },
        {
          name: 'account',
          path: 'account',
          component: () => import('@/views/account/Account.vue'),
        },
        {
          name: 'subscription',
          path: 'subscription',
          component: () => import('@/views/account/Subscription.vue'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('signin');
  else if (!requiresAuth && currentUser) next('/');
  else next();
});

export default router;